// src/components/InstallationPopup.js
import React, { useContext } from 'react';
import { ModalContext, ModalTypes } from '../store/Contexts';
import { getText } from '../i18n';
import styles from './installationPopup.module.scss';

const InstallationPopup = ({ onClose }) => {
    const { showModal } = useContext(ModalContext);

    const handleInstallClick = () => {
        showModal({ type: ModalTypes.INSTALLATION });
        onClose();
    };

    return (
        <div className={styles.backdrop}>
            <div className={styles.dialog}>
                <div className={styles.content}>
                    <i
                        className="bi bi-phone"
                        style={{ fontSize: '60px', color: '#1366FF' }}
                    />
                    <h4 className={styles.title}>
                        {getText('msg_382522cce164')}
                    </h4>
                    <p className={styles.paragraph}>
                        {getText('msg_53b58551998f')}
                    </p>
                    <div className={styles.buttonContainer}>
                        <button
                            onClick={handleInstallClick}
                            className={'ing-button-primary-none'}
                        >
                            {getText('msg_fd6c3ebf7bef')}
                        </button>
                        <button
                            onClick={onClose}
                            className={'ing-popup-blue-negative'}
                        >
                            {getText('msg_3da474537ac3')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstallationPopup;
